import {ListPresentation} from 'aplovio/list-ui';

if (!customElements.get('aplovio-collection-page')) customElements.define('aplovio-collection-page', class extends HTMLElement {
 connectedCallback() {
  if (this.presentation) return;
  this.presentation = new ListPresentation(this, {navigation:'aplovio-collection-navigation',regions:'.ap-collection-results'});
  if (this.dataset.ajax !== 'true' || window.Shopify?.designMode) return;
  this.abort = new AbortController();
  const options = {signal:this.abort.signal};
  this.animations = this.presentation.motion.animations;
  this.reducedMotion = this.presentation.motion.reducedMotion;
  this.currentURL = location.href;
  this.previousRestoration = history.scrollRestoration;
  history.scrollRestoration = 'manual';
  this.remember();
  this.addEventListener('click', event => {
   if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
   const link = event.target.closest('a[href]');
   if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
   if (!link.closest('aplovio-collection-navigation,.ap-active-filters,.ap-filter-actions,.ap-collection-empty,.ap-collection-pagination')) return;
   const url = this.collectionURL(link.href);
   if (!url || !this.supported()) return;
   event.preventDefault();
   this.load(url, {kind:link.closest('aplovio-collection-navigation') ? 'category' : 'filter'});
  }, options);
  this.addEventListener('submit', event => {
   const form = event.target;
   if (event.defaultPrevented || !form.matches('.ap-filter-form') || form.method !== 'get' || !this.supported()) return;
   const url = this.collectionURL(form.action);
   if (!url) return;
   event.preventDefault();
   url.search = new URLSearchParams([...new FormData(form)].filter(([,value]) => value !== '')).toString();
   url.hash = new URL(this.currentURL).hash;
   this.load(url, {kind:'filter'});
  }, options);
  window.addEventListener('popstate', event => {
   const url = this.collectionURL(location.href);
   if (!url) return;
   this.request?.abort();
   this.request = null;
   this.setBusy(false);
   if (url.pathname + url.search === new URL(this.currentURL).pathname + new URL(this.currentURL).search) {
    this.currentURL = url.href;
    this.querySelector('aplovio-collection-navigation')?.render();
    return;
   }
   this.load(url, {fromHistory:true, scroll:event.state?.aplovioCollection?.scroll});
  }, options);
  window.addEventListener('scroll', () => {
   clearTimeout(this.scrollTimer);
   this.scrollTimer = setTimeout(() => {if (!this.request && !window.AplovioLayers?.top()) this.remember();}, 150);
  }, {...options, passive:true});
  window.addEventListener('pagehide', () => {this.request?.abort(); this.request = null; this.setBusy(false);}, options);
  this.motionFrame = requestAnimationFrame(() => this.reveal(this.motionSnapshot(), 'entry'));
 }
 collectionURL(value) {
  try {const url = new URL(value, location.href); return url.origin === location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname) ? url : null;} catch {return null;}
 }
 supported(root = this) {
  return root.dataset.ajax === 'true' && !root.querySelector('.shopify-app-block,script:not([type="application/json"]):not([type="application/ld+json"])');
 }
 remember() {
  if (location.href !== this.currentURL) return;
  history.replaceState({...history.state, aplovioCollection:{url:this.currentURL, scroll:scrollY}}, '', location.href);
 }
 setBusy(value) {
  this.toggleAttribute('data-loading', value);
  this.toggleAttribute('data-list-loading', value);
  for (const progress of this.querySelectorAll('[data-collection-progress]')) progress.hidden = !value;
  for (const grid of this.querySelectorAll('[data-collection-grid]')) {grid.inert = value; grid.setAttribute('aria-busy', String(value));}
  this.positionLoaders();
 }
 positionLoaders() { this.presentation.update(); }
 motionSettings() { return this.presentation.motion.settings(); }
 cancelMotion() {
  cancelAnimationFrame(this.motionFrame);
  this.motionAbort?.abort();
  this.presentation?.motion.cancel();
 }
 motionSnapshot() {
  const navigation = this.querySelector('aplovio-collection-navigation');
  const indicator = navigation?.querySelector('[data-category-indicator]:not([hidden])');
  return {branch:navigation?.dataset.branch || 'root', indicator:indicator?.getBoundingClientRect().toJSON()};
 }
 reveal(previous, kind) {
  const {duration, easing} = this.motionSettings();
  if (!duration || document.hidden) return;
  this.motionAbort = new AbortController();
  const signal = this.motionAbort.signal;
  const play = (node, frames, delay=0) => {
   if (!signal.aborted) this.presentation.motion.play(node, frames, {duration, easing, delay});
  };
  if (kind === 'category' || kind === 'entry') {
   const hero = this.querySelector('[data-collection-hero]:not([hidden]) img');
   if (hero?.complete) play(hero, [{opacity:.45},{opacity:1}]);
   else hero?.addEventListener('load', () => play(hero, [{opacity:.45},{opacity:1}]), {once:true, signal});
   play(this.querySelector('[data-collection-heading]'), [{opacity:.2},{opacity:1}]);
  }
  this.presentation.motion.reveal([...this.querySelectorAll('.ap-product-card')]);
  const navigation = this.querySelector('aplovio-collection-navigation');
  const branch = navigation?.dataset.branch || 'root';
  if (previous.branch !== branch) {
   const depth = value => value === 'root' ? 0 : value.split('-').length;
   const direction = (depth(branch) >= depth(previous.branch) ? 1 : -1) * (getComputedStyle(this).direction === 'rtl' ? -1 : 1);
   play(navigation?.querySelector('[data-category-track]'), [{opacity:.35,transform:`translateX(${direction*24}px)`},{opacity:1,transform:'translateX(0)'}]);
  } else if (previous.indicator) {
   const indicator = navigation?.querySelector('[data-category-indicator]:not([hidden])');
   const bounds = indicator?.getBoundingClientRect();
   if (bounds?.width) play(indicator, [{transform:`translateX(${previous.indicator.left-bounds.left}px) scaleX(${previous.indicator.width/bounds.width})`},{transform:'translateX(0) scaleX(1)'}]);
  }
 }
 async load(url, {kind='category', fromHistory=false, scroll} = {}) {
  const oldURL = new URL(this.currentURL);
  if (fromHistory && url.pathname === oldURL.pathname) kind = 'filter';
  if (url.pathname + url.search === oldURL.pathname + oldURL.search) {
   this.request?.abort(); this.request = null; this.setBusy(false);
   if (!fromHistory && url.href !== this.currentURL) {this.remember(); history.pushState({...history.state}, '', url);}
   this.currentURL = url.href;
   this.querySelector('aplovio-collection-navigation')?.render();
   const activeLayer = window.AplovioLayers?.top();
   if (kind === 'filter' && activeLayer && this.contains(activeLayer)) window.AplovioLayers.close(activeLayer, 'apply');
   return;
  }
  if (!this.supported() || !this.dispatchEvent(new CustomEvent('aplovio:collection-beforeload', {bubbles:true, cancelable:true, detail:{url:url.href}}))) {
   location.assign(url.href); return;
  }
  if (!fromHistory) this.remember();
  this.cancelMotion();
  this.request?.abort();
  const request = this.request = new AbortController();
  const timeout = setTimeout(() => {if (this.request === request) {request.abort(); location.assign(url.href);}}, 12000);
  const oldScroll = scrollY;
  const returnToRow = kind === 'category' && oldScroll > 100;
  this.setBusy(true);
  try {
   const response = await window.AplovioLazy.read(url.href, {signal:request.signal, credentials:'same-origin', headers:{Accept:'text/html'}});
   if (!response.ok || !response.headers.get('content-type')?.includes('text/html')) throw new Error('collection-response');
   const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
   if (request.signal.aborted || this.request !== request) return;
   const next = doc.querySelector('aplovio-collection-page');
   const main = this.closest('main'), nextMain = next?.closest('main');
   const loadedScripts = new Set([...document.querySelectorAll('script[src]')].map(node => node.src));
   // Some app scripts remove their own tags after running. Retain exact script
   // request URLs as evidence; a genuinely new dependency still needs a document.
   for (const resource of performance.getEntriesByType('resource')) {
    if (resource.initiatorType === 'script' && !(resource.responseStatus >= 400)) loadedScripts.add(resource.name);
   }
   const extraScript = [...doc.querySelectorAll('script[src]')].some(node => !loadedScripts.has(new URL(node.getAttribute('src'), response.url).href));
   if (doc.body.dataset.apPage !== 'collection' || !next || !this.supported(next) || next.dataset.sectionId !== this.dataset.sectionId || main?.children.length !== 1 || nextMain?.children.length !== 1 || extraScript) throw new Error('collection-integration');
   const returned = this.collectionURL(response.url);
   if (!returned || returned.pathname !== url.pathname) throw new Error('collection-redirect');
   const activeLayer = window.AplovioLayers?.top();
   if (activeLayer && !this.contains(activeLayer)) throw new Error('collection-layer');
   if (activeLayer) window.AplovioLayers.close(activeLayer, 'disconnect', true);
   const previousMotion = this.motionSnapshot();
   if (!fromHistory) {
    const state = {...history.state};
    delete state.aplovio; delete state.aplovioLayers; delete state.aplovioCollectionAppend;
    history.pushState({...state, aplovioCollection:{url:url.href, scroll:0}}, '', url.href);
   }
   this.currentURL = url.href;
   this.replaceChildren(...[...next.childNodes].map(node => document.importNode(node, true)));
   for (const attribute of [...next.attributes]) this.setAttribute(attribute.name, attribute.value);
   const meta = 'title,link[rel="canonical"],link[rel~="alternate"][hreflang],meta[name="description"],meta[property^="og:"],meta[name^="twitter:"]';
   document.head.querySelectorAll(meta).forEach(node => node.remove());
   doc.head.querySelectorAll(meta).forEach(node => document.head.append(document.importNode(node, true)));
   for (const flag of ['desktop','mobile','light','dark']) document.body.toggleAttribute(`data-ap-initial-header-${flag}`, doc.body.hasAttribute(`data-ap-initial-header-${flag}`));
   this.setBusy(false);
   this.request = null;
   const target = kind === 'filter' ? this.querySelector('aplovio-collection-products') : this.querySelector('aplovio-collection-navigation');
   const header = document.querySelector('aplovio-header');
   window.scrollTo({top:0, behavior:'instant'});
   header?.update();
   const headerHeight = document.querySelector('.ap-header__surface')?.getBoundingClientRect().height || 0;
   const position = fromHistory && Number.isFinite(scroll) ? scroll : (kind === 'filter' || returnToRow) && target ? target.getBoundingClientRect().top + scrollY - headerHeight : 0;
   window.scrollTo({top:Math.max(0, position), behavior:'instant'});
   const focus = kind === 'filter'
     ? this.querySelector('[data-filter-open]:not([hidden])') || this.querySelector('.ap-filters-inline > summary')
     : this.querySelector('[data-category-track] [aria-current]') || this.querySelector('[data-category-track] a');
   if (!fromHistory) focus?.focus({preventScroll:true});
   this.remember();
   this.motionFrame = requestAnimationFrame(() => this.reveal(previousMotion, kind));
   this.dispatchEvent(new CustomEvent('aplovio:collection-load', {bubbles:true, detail:{url:url.href, previousURL:oldURL.href, sectionId:this.dataset.sectionId, fromHistory}}));
  } catch (error) {
   if (!request.signal.aborted && this.request === request) location.assign(url.href);
  } finally {
   clearTimeout(timeout);
   if (this.request === request) {this.request = null; this.setBusy(false);}
  }
 }
 disconnectedCallback() {
  this.cancelMotion();
  this.presentation?.destroy(); this.presentation = null;
  this.abort?.abort(); this.abort = null; this.request?.abort(); this.request = null;
  clearTimeout(this.scrollTimer);
  if (this.previousRestoration !== undefined) history.scrollRestoration = this.previousRestoration;
 }
});
if(!customElements.get('aplovio-collection-navigation'))customElements.define('aplovio-collection-navigation',class extends HTMLElement{
 connectedCallback(){
  if (this.abort) return;
  this.abort = new AbortController();
  const options = {signal: this.abort.signal};
  const fallback = this.querySelector('.ap-category-fallback');
  // Keep an open native menu usable if the script arrives during interaction.
  if (fallback?.open) {
    fallback.addEventListener('toggle', () => {
      if (fallback.open) return;
      this.abort.abort();
      this.abort = null;
      this.connectedCallback();
    }, options);
    return;
  }
  this.native=this.querySelector('.ap-category-native');this.enhanced=this.querySelector('.ap-category-enhanced');this.track=this.querySelector('[data-category-track]');this.back=this.querySelector('[data-category-back]');this.nodes=new Map();
  const walk=(list,parent=null)=>[...list.children].filter(li=>li.matches('[data-category-node]')).map(li=>{const anchor=li.querySelector(':scope > a'),node={key:li.dataset.categoryNode,label:anchor.textContent.trim(),url:anchor.href,parent,children:[]};this.nodes.set(node.key,node);const children=li.querySelector(':scope > ul');if(children)node.children=walk(children,node);return node;});
  this.roots=walk(this.native.querySelector('ul'));
  if (!this.roots.length) return; // The native All categories link remains useful for empty menus.
  this.addEventListener('click',event=>{if(this.dragged){event.preventDefault();this.dragged=false;return;}const button=event.target.closest('[data-category-scroll]');if(button){const sign=(button.dataset.categoryScroll==='next'?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1);this.track.scrollBy({left:sign*this.track.clientWidth*.7,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}},options);
  this.track.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;this.drag={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft};this.dragged=false;},options);
  window.addEventListener('pointermove',event=>{if(!this.drag||event.pointerId!==this.drag.id)return;const delta=event.clientX-this.drag.x;if(Math.abs(delta)>6){this.dragged=true;this.track.dataset.dragging='';this.track.setPointerCapture(event.pointerId);}if(this.dragged){event.preventDefault();this.track.scrollLeft=this.drag.left-delta;}},options);
  const stop=()=>{this.drag=null;delete this.track.dataset.dragging;clearTimeout(this.dragTimer);this.dragTimer=setTimeout(()=>this.dragged=false,0);};window.addEventListener('pointerup',stop,options);window.addEventListener('pointercancel',stop,options);
  this.track.addEventListener('dragstart',event=>event.preventDefault(),options);
  this.track.addEventListener('keydown',event=>{const links=[...this.track.querySelectorAll('a')],index=links.indexOf(document.activeElement);if(index<0)return;const rtl=getComputedStyle(this).direction==='rtl';let next;if(event.key==='ArrowRight')next=index+(rtl?-1:1);if(event.key==='ArrowLeft')next=index+(rtl?1:-1);if(event.key==='Home')next=0;if(event.key==='End')next=links.length-1;if(next!==undefined){event.preventDefault();links[Math.max(0,Math.min(links.length-1,next))]?.focus({preventScroll:true});document.activeElement.scrollIntoView({block:'nearest',inline:'nearest'});}},options);
  this.track.addEventListener('scroll',()=>this.overflow(),{...options,passive:true});
  this.resize=new ResizeObserver(()=>this.overflow());this.resize.observe(this.track);
  window.addEventListener('hashchange',()=>this.render(),options);
  this.render();
  this.closest('aplovio-collection-page')?.presentation?.update();
  const restoreFocus = this.native.contains(document.activeElement);
  this.enhanced.hidden = false;
  this.native.hidden = true;
  if (restoreFocus) this.track.querySelector('a')?.focus({preventScroll: true});
 }
 path(value){try{return new URL(value,location.href).pathname.replace(/\/$/,'');}catch{return '';}}
 href(node){const url=new URL(node?.url||this.dataset.rootUrl,location.href);url.hash=`category=${node?.key||'root'}`;return url.href;}
 render(){
  // An open native disclosure can intentionally postpone enhancement during history changes.
  if (!this.nodes || !this.track) return;
  const key=new URLSearchParams(location.hash.slice(1)).get('category'),currentPath=this.path(location.href);let selected=this.nodes.get(key);
  if(selected&&this.path(selected.url)!==currentPath)selected=null;
  if(!selected&&key!=='root'&&currentPath!==this.path(this.dataset.rootUrl))selected=[...this.nodes.values()].find(node=>this.path(node.url)===currentPath);
  const branch=selected?.children.length?selected:selected?.parent;const children=branch?branch.children:this.roots;
  this.dataset.branch=branch?.key||'root';
  this.track.replaceChildren();
  const append=(node,label,active)=>{const link=document.createElement('a');link.href=this.href(node);link.textContent=label;if(active)link.setAttribute('aria-current','page');this.track.append(link);};
  if(branch)append(branch,`${this.dataset.allLabel} ${branch.label}`,selected===branch);
  for(const node of children)append(node,node.label,node===selected);
  this.indicator=document.createElement('span');this.indicator.className='ap-category-indicator';this.indicator.dataset.categoryIndicator='';this.indicator.setAttribute('aria-hidden','true');this.track.append(this.indicator);
  this.back.hidden=!branch;this.back.href=this.href(branch?.parent);const backLabel=branch?.parent?.label||this.dataset.rootLabel;this.back.setAttribute('aria-label',backLabel);this.back.querySelector('.ap-category-back-label').textContent=backLabel;this.back.querySelector('.ap-category-back-mobile').textContent=branch?.parent?.label||this.back.dataset.rootShortLabel;
  this.track.scrollLeft=0;requestAnimationFrame(()=>{const active=this.track.querySelector('[aria-current]');if(active){const bounds=active.getBoundingClientRect(),track=this.track.getBoundingClientRect();if(bounds.right>track.right)this.track.scrollLeft+=bounds.right-track.right;if(bounds.left<track.left)this.track.scrollLeft+=bounds.left-track.left;}this.overflow();});
 }
 overflow(){if(!this.track)return;const overflow=this.track.scrollWidth>this.track.clientWidth+2;for(const button of this.querySelectorAll('[data-category-scroll]'))button.hidden=!overflow;const active=this.track.querySelector('[aria-current]');if(this.indicator){this.indicator.hidden=!active;if(active){const bounds=active.getBoundingClientRect(),track=this.track.getBoundingClientRect();this.indicator.style.left=`${bounds.left-track.left+this.track.scrollLeft}px`;this.indicator.style.width=`${bounds.width}px`;}}}
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);clearTimeout(this.dragTimer);}
});
if(!customElements.get('aplovio-collection-products'))customElements.define('aplovio-collection-products',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.gridLayout=window.AplovioGridLayout?.attach(this,{preserveScroll:true});
  this.owner=this.closest('aplovio-collection-page');this.baseURL=location.href;this.pages=[];
  const group=this.querySelector('.ap-grid-switch');
  if(group){
   // Editorial presets have deliberate row widths; density is a Classic control.
   group.hidden=this.dataset.layout!=='classic';
   const apply=value=>{this.dataset.density=value;group.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.gridDensity===value)));};
   try{apply(sessionStorage.getItem('aplovio-grid-density')==='dense'?'dense':'comfortable');}catch{apply('comfortable');}
   this.addEventListener('click',event=>{const button=event.target.closest('[data-grid-density]');if(!button)return;apply(button.dataset.gridDensity);try{sessionStorage.setItem('aplovio-grid-density',button.dataset.gridDensity);}catch{}},options);
  }
  if(this.dataset.loadingMode==='pagination'||window.Shopify?.designMode||!this.owner?.supported())return;
  this.enhance();
  this.addEventListener('click',event=>{
   const link=event.target.closest('[data-collection-next]');
   if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   event.preventDefault();this.autoFailed=false;this.appendPage(link.href,{focus:true});
  },options);
  this.owner.addEventListener('aplovio:collection-beforeload',()=>{this.save();this.request?.abort();this.observer?.disconnect();},options);
  window.addEventListener('pagehide',()=>{this.save();this.request?.abort();},options);
  // Only restore URL descriptors from this history entry; never persist product HTML or prices.
  const saved=history.state?.aplovioCollectionAppend;
  if(saved?.baseURL===this.baseURL&&Array.isArray(saved.pages)&&saved.pages.length){
   this.restoring=true;queueMicrotask(()=>this.restore(saved.pages,saved.scroll).finally(()=>{
    this.restoring=false;this.observe();
    this.dispatchEvent(new CustomEvent('aplovio:collection-restored',{bubbles:true,detail:{url:this.baseURL}}));
   }));
  }else this.observe();
 }
 enhance(){
  this.querySelector('.ap-collection-pagination')?.setAttribute('hidden','');
  const more=this.querySelector('[data-collection-more]');if(more)more.hidden=false;
 }
 observe(){
  this.observer?.disconnect();
  const link=this.querySelector('[data-collection-next]');
  if(this.dataset.loadingMode!=='infinite'||!link||this.autoFailed||this.restoring)return;
  this.observer=new IntersectionObserver(entries=>{
   if(entries.some(entry=>entry.isIntersecting)&&!this.request&&!this.owner.request&&!document.hidden)this.appendPage(link.href);
  },{rootMargin:'300px'});this.observer.observe(link);
 }
 nextURL(value){
  const url=this.owner.collectionURL(value),base=new URL(this.baseURL);
  if(!url||url.pathname!==base.pathname)return null;
  const query=u=>[...u.searchParams].filter(([key])=>key!=='page').sort(([a],[b])=>a.localeCompare(b)).map(pair=>JSON.stringify(pair)).join();
  const page=Number(url.searchParams.get('page'));
  if(query(url)!==query(base)||!Number.isSafeInteger(page)||page<2)return null;
  const expected=Number(new URL(this.pages.at(-1)||this.baseURL).searchParams.get('page')||1)+1;
  return page===expected?url:null;
 }
 save(){
  if(!this.pages.length||!this.isConnected||location.href!==this.baseURL)return;
  history.replaceState({...history.state,aplovioCollectionAppend:{baseURL:this.baseURL,pages:[...this.pages],scroll:scrollY}},'',location.href);
 }
 async restore(pages, scroll) {
  const interaction = new AbortController();
  let interacted = false;
  for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown']) {
   window.addEventListener(type, () => { interacted = true; }, {signal: interaction.signal, passive: true});
  }
  try {
   for (const value of pages) {
    if (!this.isConnected || !await this.appendPage(value, {restoring: true})) break;
   }
   if (this.isConnected && !interacted && Number.isFinite(scroll)) {
    window.scrollTo({top: scroll, behavior: 'instant'});
   }
   this.save();
  } finally { interaction.abort(); }
 }
 async appendPage(value,{focus=false,restoring=false}={}){
  if(this.request||this.owner.request||!this.isConnected)return false;
  const url=this.nextURL(value);if(!url)return false;
  const request=this.request=new AbortController(),more=this.querySelector('[data-collection-more]'),status=more.querySelector('[data-append-status]');
  const timeout=setTimeout(()=>request.abort('timeout'),12000);
  more.dataset.busy='';status.textContent=status.dataset.loading;
  more.querySelector('a')?.setAttribute('aria-disabled','true');this.observer?.disconnect();
  try{
   const response=await window.AplovioLazy.read(url.href,{credentials:'same-origin',signal:request.signal,headers:{Accept:'text/html'}});
   if(!response.ok||!response.headers.get('content-type')?.includes('text/html'))throw new Error('response');
   const returned=this.nextURL(response.url);if(!returned||returned.search!==url.search)throw new Error('redirect');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html'),nextOwner=doc.querySelector('aplovio-collection-page'),next=nextOwner?.querySelector('aplovio-collection-products');
   const loadedScripts=new Set([...document.querySelectorAll('script[src]')].map(node=>node.src));
   if(!next||doc.body.dataset.apPage!=='collection'||nextOwner.dataset.sectionId!==this.owner.dataset.sectionId||!this.owner.supported(nextOwner)||[...doc.querySelectorAll('script[src]')].some(node=>!loadedScripts.has(new URL(node.getAttribute('src'),response.url).href)))throw new Error('integration');
   if(request.signal.aborted||!this.isConnected||this.request!==request)return false;
   const grid=this.querySelector('[data-collection-grid]'),nextGrid=next.querySelector('[data-collection-grid]'),nextMore=next.querySelector('[data-collection-more]');
   if(!nextGrid||!nextMore)throw new Error('pagination');
   const keys=new Set([...grid.children].map(node=>node.dataset.gridProduct?'p:'+node.dataset.gridProduct:'e:'+node.dataset.gridEditorial));
   const additions=[...nextGrid.children].filter(node=>{const key=node.dataset.gridProduct?'p:'+node.dataset.gridProduct:node.dataset.gridEditorial?'e:'+node.dataset.gridEditorial:null;if(!key||keys.has(key))return false;keys.add(key);return true;});
   if(!additions.some(node=>node.dataset.gridProduct))throw new Error('empty-page');
   const focused=more.contains(document.activeElement);
   const nodes=additions.map(node=>document.importNode(node,true));grid.append(...nodes);this.gridLayout?.layout();
   more.replaceChildren(...[...nextMore.childNodes].map(node=>document.importNode(node,true)));
   const pagination=this.querySelector('.ap-collection-pagination'),nextPagination=next.querySelector('.ap-collection-pagination');
   if(pagination&&nextPagination)pagination.replaceChildren(...[...nextPagination.childNodes].map(node=>document.importNode(node,true)));
   this.pages.push(url.href);this.save();
   const newStatus=more.querySelector('[data-append-status]');
   if(!more.querySelector('[data-collection-next]'))newStatus.textContent=newStatus.dataset.complete;
   if(focus&&focused)nodes.find(node=>node.dataset.gridProduct)?.querySelector('a')?.focus({preventScroll:true});
   this.dispatchEvent(new CustomEvent('aplovio:collection-load',{bubbles:true,detail:{url:this.baseURL,pageURL:url.href,append:true,fromHistory:restoring,sectionId:this.owner.dataset.sectionId}}));
   return true;
  }catch(error){
   if(this.isConnected&&(!request.signal.aborted||request.signal.reason==='timeout')){status.textContent=status.dataset.error;this.autoFailed=true;}
   return false;
  }finally{
   clearTimeout(timeout);delete more.dataset.busy;more.querySelector('a')?.removeAttribute('aria-disabled');
   if(this.request===request)this.request=null;
   if(this.isConnected&&!restoring)this.observe();
  }
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.request?.abort();this.request=null;this.observer?.disconnect();this.gridLayout?.destroy();}
});
if (!customElements.get('aplovio-collection-filters')) {
  customElements.define('aplovio-collection-filters', class extends HTMLElement {
    async connectedCallback() {
      if (this.abort) return;
      const controller = new AbortController();
      this.abort = controller;
      const options = {signal: controller.signal};
      this.form = this.querySelector('form');
      this.inline = this.querySelector('.ap-filters-inline');
      this.layer = this.querySelector('aplovio-layer');
      this.trigger = this.querySelector('[data-filter-open]');
      if (!this.form || !this.inline || !this.layer || !this.trigger) return;

      // If the layer script is delayed or unavailable, the native GET form stays usable.
      if (!customElements.get('aplovio-layer')) await customElements.whenDefined('aplovio-layer');
      if (controller.signal.aborted || !this.isConnected) return;
      const enhance = () => {
        if (this.inline.open || this.inline.hidden || controller.signal.aborted) return;
        const slot = this.layer.querySelector('[data-filter-slot]');
        if (!slot || typeof this.layer.open !== 'function') return;
        const restoreFocus = this.inline.contains(document.activeElement);
        slot.append(this.form);
        this.inline.hidden = true;
        this.trigger.hidden = false;
        if (restoreFocus) this.trigger.focus({preventScroll: true});
      };
      this.inline.addEventListener('toggle', enhance, options);
      this.trigger.addEventListener('click', () => this.layer.open(this.trigger), options);
      this.layer.addEventListener('aplovio:layer-open', () => {
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.layer.addEventListener('aplovio:layer-close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
      }, options);
      this.addEventListener('shopify:block:select', () => this.layer.open(this.trigger), options);
      this.addEventListener('shopify:block:deselect', () => this.layer.close('editor'), options);
      enhance();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      if (this.form && this.inline) this.inline.append(this.form);
      if (this.inline) this.inline.hidden = false;
      if (this.trigger) {
        this.trigger.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });
}
